import { Link } from "react-router-dom";
import "./DashboardV4.css";

export default function DashboardV4(): JSX.Element {
  const supporters = [
    { name: "James Lockwood", started: "Jun '23", monthly: 250, total: 9000, tier: "Architect" },
    { name: "Helena Voss",    started: "Dec '23", monthly: 100, total: 3000, tier: "Founder" },
    { name: "M.J. Asante",    started: "Apr '24", monthly:  50, total: 1300, tier: "Benefactor" },
    { name: "Dr. Owen Hayes", started: "May '25", monthly:  25, total:  325, tier: "Patron" },
    { name: "Camille Joubert",started: "Jun '25", monthly:  25, total:  300, tier: "Patron" },
    { name: "Hiro Tanaka",    started: "Aug '25", monthly:  10, total:  100, tier: "Member" },
    { name: "Lena R.",        started: "Aug '25", monthly:  10, total:  100, tier: "Member" },
    { name: "Sarah K.",       started: "Sep '25", monthly:   5, total:   45, tier: "Supporter" },
    { name: "Marcus T.",      started: "Sep '25", monthly:   5, total:   45, tier: "Supporter" },
    { name: "Priya N.",       started: "Oct '25", monthly:   5, total:   40, tier: "Supporter" },
  ];
  const mrr = supporters.reduce((s, x) => s + x.monthly, 0);
  const fee = Math.round(mrr * 0.049);
  const takeHome = mrr - fee;
  const totalLifetime = supporters.reduce((s, x) => s + x.total, 0);

  return (
    <div className="pp-page dbg4">
      <aside className="dbg4-side">
        <Link to="/" className="dbg4-brand">
          <span className="dbg4-brand-glyph"></span> SubsWall
        </Link>
        <nav>
          <a className="dbg4-nav-link dbg4-active">⌂ Home</a>
          <a className="dbg4-nav-link">⌽ Supporters <span>{supporters.length}</span></a>
          <a className="dbg4-nav-link">$ Earnings</a>
          <a className="dbg4-nav-link">⌜ Wall settings</a>
          <a className="dbg4-nav-link">⇲ Payouts</a>
          <a className="dbg4-nav-link">&lt;/&gt; Embed</a>
          <div className="dbg4-divider"></div>
          <a className="dbg4-nav-link">⚙ Account</a>
          <a className="dbg4-nav-link">→ Sign out</a>
        </nav>
        <Link to="/demo" className="dbg4-side-foot">View public wall ↗</Link>
      </aside>

      <main className="dbg4-main">
        <header className="dbg4-head">
          <div>
            <div className="pp-eyebrow">Welcome back, Demo</div>
            <h1 className="pp-display dbg4-h1">Your wall.</h1>
          </div>
          <Link to="/demo" className="pp-btn pp-btn-ghost">Open public wall →</Link>
        </header>

        <section className="dbg4-kpis">
          <div className="pp-card dbg4-kpi">
            <div className="pp-eyebrow">Monthly recurring</div>
            <div className="pp-mono dbg4-kpi-num">${mrr.toLocaleString()}</div>
            <div className="dbg4-kpi-sub">${takeHome.toLocaleString()} to you · ${fee} fee</div>
          </div>
          <div className="pp-card dbg4-kpi">
            <div className="pp-eyebrow">Supporters</div>
            <div className="pp-mono dbg4-kpi-num">{supporters.length}</div>
            <div className="dbg4-kpi-sub">+2 this month · 0 cancellations</div>
          </div>
          <div className="pp-card dbg4-kpi">
            <div className="pp-eyebrow">Lifetime</div>
            <div className="pp-mono dbg4-kpi-num">${totalLifetime.toLocaleString()}</div>
            <div className="dbg4-kpi-sub">Across all supporters</div>
          </div>
          <div className="dbg4-kpi dbg4-kpi-accent">
            <div className="pp-eyebrow">Next payout</div>
            <div className="pp-mono dbg4-kpi-num">${takeHome.toLocaleString()}</div>
            <div className="dbg4-kpi-sub">Stripe · 1st of next month</div>
          </div>
        </section>

        <section className="dbg4-section">
          <div className="dbg4-section-head">
            <h2 className="pp-display dbg4-h2">Your supporters</h2>
            <div className="dbg4-tools">
              <input type="search" placeholder="Search…" />
              <button className="pp-btn pp-btn-ghost pp-btn-sm">Export CSV</button>
            </div>
          </div>
          <div className="dbg4-table-wrap">
            <table className="dbg4-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Since</th>
                  <th className="dbg4-num">Monthly</th>
                  <th className="dbg4-num">Lifetime</th>
                  <th>Tier</th>
                </tr>
              </thead>
              <tbody>
                {supporters.map((s) => (
                  <tr key={s.name}>
                    <td>{s.name}</td>
                    <td className="dbg4-mute pp-mono">{s.started}</td>
                    <td className="dbg4-num pp-mono">${s.monthly}</td>
                    <td className="dbg4-num pp-mono">${s.total.toLocaleString()}</td>
                    <td><span className={`dbg4-tier dbg4-t-${s.tier.toLowerCase()}`}>{s.tier}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>

        <section className="dbg4-section">
          <div className="dbg4-section-head">
            <h2 className="pp-display dbg4-h2">Embed your wall</h2>
          </div>
          <p className="pp-lead dbg4-embed-copy">
            Paste anywhere — YouTube About page, video descriptions, your own
            site. Updates live as new supporters sign on.
          </p>
          <pre className="dbg4-code pp-mono">{`<iframe src="https://subswall.com/demo/embed"
        width="100%" height="600"
        style="border:0;border-radius:14px;"
        loading="lazy"></iframe>`}</pre>
        </section>
      </main>
    </div>
  );
}
